/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js";

export default {
  // eslint-disable-next-line no-unused-vars
  join({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post("student-in-class", payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  // eslint-disable-next-line no-unused-vars
  update({ commit }, { enrollment_id, payload }) {
    return new Promise((resolve, reject) => {
      axios
        .put(`student-in-class/${enrollment_id}`, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  // eslint-disable-next-line no-unused-vars
  transfer({ commit }, { enrollment_id, payload }) {
    return new Promise((resolve, reject) => {
      axios
        .post(`student-in-class/${enrollment_id}/transfer`, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  studentLeaveClass({ commit }, enrollment_id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`student-in-class/${enrollment_id}`)
        .then((response) => {
          commit("STUDENT_LEAVED_CLASS", enrollment_id);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};
